// ============================================================
// types/exoneracion.types.ts
// ============================================================

export type TipoExoneracion = 'TOTAL' | 'PARCIAL';

export const TIPO_EXONERACION_LABEL: Record<TipoExoneracion, string> = {
  TOTAL:   'Total',
  PARCIAL: 'Parcial',
};

export const TIPO_EXONERACION_COLOR: Record<TipoExoneracion, string> = {
  TOTAL:   'bg-green-100 text-green-700',
  PARCIAL: 'bg-blue-100 text-blue-700',
};

export interface ExoneracionResponse {
  idExoneracion:       number;
  matriculaId:         number;
  cursoId:             number;
  cursoNombre:         string;
  estudianteId:        number;
  estudianteNombres:   string;
  estudianteApellidos: string;
  estudianteDni:       string;
  gradoNombre:         string;
  gradoNivel:          string;
  seccionNombre:       string;
  anio:                number;
  tipo:                TipoExoneracion;
  motivo:              string | null;
  documentoReferencia: string | null;
  activo:              boolean;
  registradoPorNombre: string;
  fechaRegistro:       string;
}

export interface ExoneracionPayload {
  matriculaId:          number;
  cursoId:              number;
  tipo:                 TipoExoneracion;
  motivo?:              string;
  documentoReferencia?: string;
}
